const SUMMARY_PARAMETERS = [
  { accessor: "accuracy", parameter: "Accuracy" },
  { accessor: "balanced_accuracy", parameter: "Balanced Accuracy" },
  { accessor: "precision", parameter: "Precision" },
  { accessor: "recall", parameter: "Coverage/Recall" },
];

const CHART_STYLE = {
  pathColor: "#4A57C4",
  trailColor: "#EBF4EC",
  textColor: "#4A57C4",
  textSize: "1.25rem",
  pathTransitionDuration: 0.75,
};

export { SUMMARY_PARAMETERS, CHART_STYLE };
